import React from "react";
import { Button } from "antd";
import { YhForm } from "@/components/YhFormBox";
import { FormItemTypeEnum, IYhForm } from "@/components/YhFormBox/Types";
import { useDictModel } from "../dictModel";
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";
export const FormBox = () => {
    const { mode, setSelectedNodes, onSubmit, onLocalSubmit, formVal, onChangeFormVal } = useDictModel();
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)

    const formConfig: IYhForm = {
        labelCol: { span: 6 },
        formValues: formVal,
        onChange: onChangeFormVal,
        items: [
            {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "父级编码",
                fieldLabel: Locale["PCode"],
                fieldName: "pcode",
                span: 18,
                disable: true
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "编码",
                fieldLabel: Locale["Code"],
                fieldName: "code",
                span: 18,
                disable: mode === "edit" ? true : false,
                rules: [{ required: true, message: "该项为必填项" }]              
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "名称",
                fieldLabel: Locale["Names"],
                fieldName: "name",
                span: 18,
                rules: [{ required: true, message: "该项为必填项" }]
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "名称",
                fieldLabel: Locale["NamesEn"],
                fieldName: "nameEn",
                span: 18,                
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "备注",
                fieldLabel: Locale["Note"],
                fieldName: "note",
                span: 18,
            }, {
                type: FormItemTypeEnum.Switch,
                // fieldLabel: "状态",
                fieldLabel: Locale["Status"],
                fieldName: "enable",
                span: 18,
            }
        ]
    };


    return (
        <>
            <div className="dict-list-header">
                <Button type="link" shape="round" onClick={onLocalSubmit}>{Locale["Local Save"]}</Button>
                <Button type="link" shape="round" onClick={onSubmit}>{Locale["Save"]}</Button>
                <Button type="link" shape="round" onClick={() => setSelectedNodes([])}>{Locale["cancel"]}</Button>
            </div>
            <div className="dict-from-content">
                <YhForm {...formConfig} />
            </div>
        </>
    )
}